import get from 'lodash.get';
import set from 'lodash.set';

/**
 * Collect list of supported apps from all apps
 * @param {Object} apps app object in format { <app name> : <app object> }
 * @returns {Array} with supported apps
 */
export const getSupportedApps = (apps, supportedApps) =>
    Object.keys(apps).filter(appName => supportedApps.includes(appName));

/**
 * Group data into multilevel nested objects based on fields param
 * @param {Array<Object>} data that needs to be grouped
 * @param {Array<String>} fields path that define keys that are used to
 *                       get values from data. Values are used as keys for multilevel nested objects.
 * @returns {Object} with grouped data by fields param
 */
export const getGroupedData = (data, fields = []) =>
    data.reduce((groupedData, item) => {
        fields.forEach((__, index, { length }) => {
            const path = fields.slice(0, index + 1).map(field => item[field]);
            const filteredPath = path.filter(pathItem => !!pathItem);
            set(
                groupedData,
                filteredPath,
                index + 1 === length ? item : get(groupedData, filteredPath, {}),
            );
        });

        return groupedData;
    }, {});
